import { render, staticRenderFns } from "./SocialShareModal.vue?vue&type=template&id=549aa3e2&"
import script from "./SocialShareModal.vue?vue&type=script&lang=js&"
export * from "./SocialShareModal.vue?vue&type=script&lang=js&"
import style0 from "./SocialShareModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports